import gql from 'graphql-tag';

export default gql`
fragment AdminProductListAdFragment on AdminProductListAd {
    id
    name
    type
    image_url_desktop
    image_url_mobile
    urls {
        url
    }
    is_active
    active_from
    active_to
    created_at
    updated_at
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminProductListAdFragment.ts